import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { createGlobalStyle } from 'styled-components'
import { ReactComponent as Logo } from '@assets/images/logo.svg'
import CommonFormInput from '@components/common/CommonFormInput'
import CommonButton from '@components/common/CommonButton'
import { useUserContext } from '../hooks/useUserContext'

const LoginPage = () => {
  const { handleLogin } = useUserContext()
  const [userInfo, setUserInfo] = useState({
    email: '',
    password: '',
  })

  const setValue = e => {
    const { name, value } = e.target

    setUserInfo({
      ...userInfo,
      [name]: value,
    })
  }

  return (
    <>
      <LoginPageStyle />
      <div className="main-wrapper">
        <Logo
          className="header-logo"
          style={{ width: '50px', height: '50px' }}
        />
      </div>
      <CommonFormInput
        name="email"
        className="form-item"
        label="이메일"
        fontWeight="normal"
        fontSize={16}
        tag="h3"
        width="100%"
        onChange={setValue}
        placeholder="이메일을 입력해주세요"
      />
      <CommonFormInput
        name="password"
        type="password"
        className="form-item"
        label="비밀번호"
        fontWeight="normal"
        fontSize={16}
        tag="h3"
        width="100%"
        onChange={setValue}
        placeholder="비밀번호를 입력해주세요"
      />

      <div className="main-wrapper">
        <CommonButton
          className="button-item"
          text="로그인"
          width="100%"
          height={70}
          backgroundColor="#ffa34b"
          fontSize={20}
          color="#FFFFFF"
          onClick={() => handleLogin(userInfo)}
        />
      </div>
    </>
  )
}

LoginPage.propTypes = {}

const LoginPageStyle = createGlobalStyle`
    .main-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
    .header-logo {
        margin-top: 40px;
        margin-bottom: 80px;
    }
    .form-item {
        margin-top: 25px;
    }
    .button-item {
        margin-top: 60px;
    }
`

export default LoginPage
